<template>
  <div class="order">
    <div class="order-content">
      <div class="order-title">
        <h2>消耗记录</h2>
      </div>
      <div class="order-btn">
        <el-input placeholder="输入金额" v-model="money"></el-input>
        <el-button type="primary" @click="topup">充值 </el-button>
      </div>
      <div>
        <el-select
          v-model="chooseInfor.status"
          placeholder="请选择"
          @change="choosestatus"
        >
          <el-option
            v-for="item in options"
            :key="item.status"
            :label="item.label"
            :value="item.status"
          >
          </el-option>
        </el-select>
      </div>
      <div>
        <el-table :data="orderData" style="width: 100%">
          <el-table-column label="ID" >
            <template slot-scope="scope">
              <span >{{ scope.row.id }}</span>
            </template>
          </el-table-column>
          <el-table-column label="流水号" >
            <template slot-scope="scope">
              <span >{{ scope.row.serial_number }}</span>
            </template>
          </el-table-column>
		  <el-table-column label="调用产品" >
		    <template slot-scope="scope">
		      <span >{{ scope.row.snapshot.title|无 }}</span>
		    </template>
		  </el-table-column>
          <el-table-column label="消耗时间" >
            <template slot-scope="scope">
              <span >{{ scope.row.updatetime }}</span>
            </template>
          </el-table-column>
          <el-table-column label="消费金额">
            <template slot-scope="scope">
              <span style="margin-left: 10px">{{ scope.row.money }}</span>
            </template>
          </el-table-column>
          <el-table-column label="余额" >
            <template slot-scope="scope">
              <span style="margin-left: 10px">{{
                scope.row.change_money_befor
              }}</span>
            </template>
          </el-table-column>
          <el-table-column label="操作">
            <template slot-scope="scope">
              <el-button
                size="mini"
                type="success"
                @click="pay(scope.$index, scope.row)"
                v-if="scope.row.status == 0"
                >支付</el-button
              >
              <div v-if="payInfo" class="pay-info">
                <h3>支付信息：</h3>
                <p>{{ payInfo }}</p>
              </div>

              <el-button
                size="mini"
                type="danger"
                @click="handleDelete(scope.$index, scope.row)"
                v-if="scope.row.status == 0"
                >删除订单</el-button
              >
              <el-button
                size="mini"
                type="warning"
                @click="handleEdit(scope.$index, scope.row)"
                v-if="scope.row.status == 0"
                >取消充值</el-button
              >
              <el-button size="mini" type="danger" v-else>
                {{
                  scope.row.status == 1
                    ? "成功"
                    : scope.row.status == 2
                    ? "失败"
                    : "已取消"
                }}
              </el-button>
            </template>
          </el-table-column>
        </el-table>
        
        <!-- 分页组件 -->
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="pagination.page"
          :page-sizes="[5, 15, 50, 100]"
          :page-size="pagination.limit"
          layout="total, sizes, prev, pager, next, jumper"
          :total="pagination.total">
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      money: "",
      orderData: [],
      options: [
        {
          status: 0,
          label: "待支付",
        },
        {
          status: 1,
          label: "成功",
        },
        {
          status: 2,
          label: "失败",
        },
        {
          status: 3,
          label: "已取消",
        },
        {
          status: 1000,
          label: "全部 ",
        },
      ],

      chooseInfor: {
        type: "2",
        status: 1000,
      },
      payInfo: "", 
      
      // 分页数据
      pagination: {
        page: 1,
        limit: 15,
        total: 0
      }
    };
  },
  methods: {
    back() {
      //返回首页
      this.$router.push({ path: "/market" });
    },
    async handleEdit(index, row) {
      //取消充值
      const res = await this.$api.order.canceOrder({ orderId: row.id });
      console.log(res);
      if (res.code == 200) {
        this.$message.success("取消成功");
      }
      this.getOrder();
    },
    async handleDelete(index, row) {
      //订单删除
      const res = await this.$api.order.delOrder({ orderId: row.id });
      console.log(res);
      this.getOrder();
    },
    cancel(index, row) {
      //充值
      console.log(index, row);
      this.getOrder();
    },
    async getOrder() {
      //订单列表 - 修改为支持分页的请求
      const params = {
        ...this.chooseInfor,
        page: this.pagination.page,
        limit: this.pagination.limit
      };
      
      const res = await this.$api.order.getOrderList(params);
      console.log("消耗记录", res);
      if (res.code == 200) {
        this.orderData = res.data.list || res.data; // 根据实际返回结构调整
        this.pagination.total = res.data.total || 0; // 根据实际返回结构调整
      }
    },
    async topup() {
      //充值订单
      if (!this.money) {
        this.$message.warning("请输入金额");
        return;
      } else {
        const res = await this.$api.order.gotopUpt({ money: this.money });
        // 先提前打开空白窗口（避免被拦截）
        const payWindow = window.open(
          "",
          `pay_${Date.now()}`,
          "width=800,height=600"
        );
        if (!payWindow) {
          this.$message.warning("浏览器拦截了支付窗口，请允许弹窗后重试");
          return;
        }
        try {
          const res = await this.$api.order.gotopUpt({ money: this.money });
          console.log(123, res);
          // 写入内容到新窗口
          payWindow.document.write(res);
          payWindow.document.close();
          this.getOrder();
        } catch (e) {
          // 接口失败时关闭空白窗口
          payWindow.close();
          this.$message.error("充值请求失败：" + e.message);
        }
        await this.getOrder();
      }
    },
    choosestatus(value) {
      //选择订单列表
      console.log("选择的status:", value);
      // 重置页码为第一页
      this.pagination.page = 1;
      this.getOrder();
    },
    async pay(index, row) {
      try {
        //支付
        const res = await this.$api.order.orderPay({ orderId: row.id });
        // 先提前打开空白窗口（避免被拦截）
        const payWindow = window.open(
          "",
          `pay_${Date.now()}`,
          "width=800,height=600"
        );
        if (!payWindow) {
          this.$message.warning("浏览器拦截了支付窗口，请允许弹窗后重试");
          return;
        }
        // 写入内容到新窗口
        payWindow.document.write(res);
        payWindow.document.close();
        this.getOrder();
      } catch (e) {
        // 接口失败时关闭空白窗口
        payWindow.close();
        this.$message.error("充值请求失败：" + e.message);
      }
      this.getOrder();
    },
    
    handleSizeChange(val) {
      console.log("分页大小改变", val);
      this.pagination.limit = val;
      this.pagination.page = 1; 
      this.getOrder();
    },
    handleCurrentChange(val) {
      
      this.pagination.page = val;
      this.getOrder();
    }
  },
  created() {
    this.getOrder();
  },
};
</script>

<style lang="scss">
.order {
  padding: 10px;
  background-color: #f1f4fb;
  height: 100vh;

  .order-btn {
    display: flex;
    align-items: center;
    .choose {
      height: 40px;
      padding: 0 20px;
      display: flex;
      align-items: center;
    }
  }
  .order-content {
    background-color: #ffffff;
    padding: 10px;
    height: 100%;
    .el-input {
      width: 200px;
    }
  }
  .order-title {
    display: flex;
    justify-content: space-between;
    line-height: 52px;
  }
  .pay-info {
    margin-top: 20px;
    padding: 15px;
    background-color: #e8f4fd;
    border-radius: 4px;

    h3 {
      margin-top: 0;
      color: #333;
    }

    p {
      margin: 0;
      color: #666;
      font-size: 14px;
    }
  }
  .el-table{
    span{
      font-size: 10px;
    }
  }
  
  // 分页样式
  .el-pagination {
    margin-top: 20px;
    text-align: right;
  }
}
</style>